// extracted by mini-css-extract-plugin
export default {"footer":"BioEditModal_footer__6ZFFr","cancel_btn":"BioEditModal_cancel_btn__FtXJg"};